import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid1x3Horizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDotGrid1x3Horizontal"><Path d="M5.5 10.25H2V13.75H5.5V10.25Z" fill="currentColor"/><Path d="M13.75 10.25H10.25V13.75H13.75V10.25Z" fill="currentColor"/><Path d="M22 10.25H18.5V13.75H22V10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3Horizontal;
